/**
 * uPlot reads navigator.language at module load and throws on invalid tags
 * such as "en-US@posix" (common on Linux CI / headless Chromium).
 */
export function ensureIntlCompatibleNavigatorLanguage() {
  if (typeof navigator === 'undefined') return;

  const language = navigator.language;
  if (!language || !language.includes('@')) return;

  try {
    // eslint-disable-next-line no-new
    new Intl.NumberFormat(language);
  } catch {
    Object.defineProperty(navigator, 'language', {
      configurable: true,
      value: 'en-US',
    });
  }
}

export async function loadUplot() {
  ensureIntlCompatibleNavigatorLanguage();
  await import('uplot/dist/uPlot.min.css');
  const mod = await import('uplot');
  return mod.default;
}
